import React from 'react'

const KeyIcon = props => {
  const height = props.height || 20
  const width = props.width || 20
  const color = props.color || '#202020'
  const strokeWidth = props.strokeWidth || '1'
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g
        transform="translate(1.333 5.333)"
        stroke={color}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="2.667" cy="2.667" r="2.667" />
        <path d="M5.333 2.667h8V6M10.667 2.667V6" />
      </g>
    </svg>
  )
}

export default KeyIcon
